<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fbxz2d/tc-custom/9780830887613.jpg?1696025337817" alt="This image is the cover for the book From Jerusalem to Timbuktu"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Jerusalem to Timbuktu
      </h1>
      <p class="bookDescription body article font2">
        <p>Christianity started in Jerusalem. For many centuries it was concentrated in the West, in Europe and North America. But in the past century the church expanded rapidly across Africa, Latin America, and Asia. Thus Christianity's geographic center of density is now in the West African country of Mali—in Timbuktu. What led to the church's vibrant growth throughout the Global South? Brian Stiller identifies five key factors that have shaped the church, from a renewed openness to the move of the Holy Spirit to the empowerment of indigenous leadership. While in some areas Christianity is embattled and threatened, in many places it is flourishing as never before. Discover the surprising story of the global advance of the gospel. And be encouraged that Jesus' witness continues to the ends of the earth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian C. Stiller
      </h2>
      
      <p class="authorDescription body article"><p>Brian C. Stiller is global ambassador for the World Evangelical Alliance. He previously served as president of Tyndale University College and Seminary in Toronto and was the founder and editor of Faith Today magazine. He is the author of eleven books, including <em>Evangelicals Around the World</em> and <em>An Insider's Guide to Praying for the World</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d6f64a9